module.exports = __webpack_public_path__ + "static/media/uow.7a1bce50.png";